import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ToastProvider } from './components/Toast';

// Global error handlers to prevent blank screens on mobile
window.addEventListener('error', (event) => {
  console.error('[Global Error]', event.error?.message || event.message);
  // Prevent the error from bubbling up and causing blank screens
  // React ErrorBoundary will handle rendering errors
});

window.addEventListener('unhandledrejection', (event) => {
  console.error('[Unhandled Promise]', event.reason?.message || event.reason);
  // Prevent unhandled promise rejections from crashing the app
  event.preventDefault();
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ToastProvider>
      <App />
    </ToastProvider>
  </React.StrictMode>
);
